'use client';

import { useEffect, useRef } from 'react';
import { apiClient } from '@/lib/api';
import { getRefreshToken } from '@/lib/authStorage';

// Интервал проактивного обновления access-токена (50 мин; access живёт 1 ч).
const REFRESH_INTERVAL_MS = 50 * 60 * 1000;

export default function AuthRefreshPoller() {
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    function scheduleRefresh() {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      if (!getRefreshToken()) return;
      intervalRef.current = setInterval(() => {
        if (!getRefreshToken()) {
          if (intervalRef.current) clearInterval(intervalRef.current);
          intervalRef.current = null;
          return;
        }
        void apiClient.refreshToken();
      }, REFRESH_INTERVAL_MS);
    }

    scheduleRefresh();
    const onAuthChanged = () => scheduleRefresh();
    window.addEventListener('lisad_auth_changed', onAuthChanged);
    return () => {
      window.removeEventListener('lisad_auth_changed', onAuthChanged);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  return null;
}
